import { Box, Flex, FlexProps } from '@chakra-ui/react'
import React from 'react'

const StatusBar = ({ color }: { color: string }) => (
  <Box
    backgroundColor={color}
    bottom={0}
    left={0}
    position="absolute"
    top={0}
    width={['6px', '12px']}
  />
)

interface Props extends FlexProps {
  center?: boolean
  children: React.ReactNode
  error?: boolean
  fit?: boolean
  fullHeight?: boolean
  fullSize?: boolean
  fullWidth?: boolean
  scrollable?: boolean
  statusColor?: string
}

const ChakraCard = ({
  center,
  children,
  error,
  fit,
  fullHeight,
  fullSize,
  fullWidth,
  scrollable,
  statusColor,
  ...props
}: Props) => {
  const width = fit ? 'fit-content' : fullWidth || fullSize ? 'full' : 'auto'

  const height = fullHeight || fullSize ? '100%' : 'auto'

  return (
    <Flex
      bgColor="white.0"
      border="1px solid"
      borderColor={error ? 'red' : 'neutral.20'}
      boxShadow="0 1px 3px 0 rgba(0, 0, 0, 0.05)"
      // TODO: Should use borderRadius from theme (base)
      height={height}
      // TODO: Should use boxShadow from theme (small)
      mx={center ? 'auto' : 'unset'}
      overflowY={scrollable ? 'auto' : 'hidden'}
      p={5}
      pl={statusColor ? ['26px', '32px'] : undefined}
      position="relative"
      width={width}
      {...props}
    >
      {statusColor && <StatusBar color={statusColor} />}
      {children}
    </Flex>
  )
}

export { ChakraCard }
